export default __webpack_public_path__ + "bfb84e82aefb1129692fe5c1930937a0.jpeg";